
/* Laura Slings - SmartSize scroll fix */

(() => {
  let savedScrollY = null;
  let wasDialogOpen = false;

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest(
      '#sizefox-enable .smartsize-trigger--floating'
    );

    if (!trigger) return;

    savedScrollY = window.scrollY;
    wasDialogOpen = false;
  }, true);

  const observer = new MutationObserver(() => {
    if (savedScrollY === null) return;

    const dialog = document.querySelector(
      '#smartsize-dialog, [role="dialog"][aria-label="SIZE GUIDE"]'
    );

    const isDialogOpen = Boolean(
      dialog && dialog.getClientRects().length > 0
    );

    if (isDialogOpen) {
      wasDialogOpen = true;
    }

    if (wasDialogOpen && !isDialogOpen) {
      wasDialogOpen = false;

      const restoreY = savedScrollY;
      savedScrollY = null;

      requestAnimationFrame(() => {
        window.scrollTo({
          top: restoreY,
          behavior: 'instant'
        });
      });
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['style', 'class', 'aria-hidden']
  });

  console.log('Laura Slings SmartSize scroll fix loaded');
})();
